import React, { useEffect, useState, useRef } from 'react';
import { Container, Typography, Box, Button, Card, CardMedia, CardContent, Stack, TextField, Divider, Accordion, AccordionSummary, AccordionDetails, Avatar } from '@mui/material';



const FaqSection = () => {
    const [activeIndex, setActiveIndex] = useState(0);

    const faqs = [
        {
        question: "What is Academillion?",
        answer: [ 
            "Academillion is your exclusive club where you learn smarter, invest with confidence, and connect with inspiring people. Here, you build your future step by step, alongside a dynamic community that supports you in achieving your biggest goals.",
        ],
        },
        {
        question: "Which package is right for me?",
        answer: [
            "• <strong> TITANIUM: </strong> Every great financial journey starts with a strong foundation. This membership is for you if you’re ready to gain <strong> clarity, confidence, and essential financial education </strong> to take control of your future. You’ll have access to <strong> expert insights, community-driven activities, and valuable learning experiences</strong>—because the right knowledge is the key to smart investing and long-term success.",
            "• <strong> SILVER: </strong> You’ve built a solid financial base, and now it’s time to take action. This membership is for investors who want to <strong> refine their strategies, connect with a powerful network, and access exclusive investment opportunities </strong> that can accelerate their growth. If you’re ready to step into the next level of investing with confidence, this is where bold financial decisions start.",
            "• <strong> GOLD: </strong> You’re not just looking for opportunities—you’re looking for the <strong> right opportunities, backed by strategy and expert guidance. </strong> This membership is for investors who want <strong> exclusive access to high-level deals and personalized financial coaching </strong> to create a clear, custom roadmap for their wealth journey. Here, you move with purpose, strategy, and the confidence to build lasting financial success.",
        ],
        },
        {
        question: "Who creates the Academillion courses?",
        answer: [ 
            "Academillion courses are crafted by industry experts and seasoned professionals who share practical knowledge, insights, and strategies from their real-world experience.",
        ],
        },
        {
        question: "How does the guarantee work?",
        answer: [ 
            "You have 15 days to test the platform risk-free. If it doesn’t meet your expectations, simply contact support office@academillion.com for a full refund.",
        ],
        },
        {
        question: "How can I pay?",
        answer: [ 
            "Payments are accepted exclusively via bank transfer.",
        ],
        },
        {
        question: "Can I pay on behalf of a business?",
        answer: [
            "We issue tax invoices for every member. You can use your company’s card to pay for membership and receive a tax invoice deductible for your business. For a complete invoice, please ensure your company’s billing details are provided when issuing the invoice.",
        ],
        },
    ];

    const handleAccordionChange = (index) => {
        setActiveIndex((prevIndex) => (prevIndex === index ? null : index));
    };

    return(
        <Box sx={{ py: { xs: 2, xxl: 6 }, px: 2, backgroundColor: "#F4F4F4", textAlign: "center"}}>
            <Typography
                variant="h2"
                sx={{
                    mb: { xs: 2, xxl: 4 },
                    fontWeight: "bold", 
                    color: '#20defa',
                    fontSize: { xs: "20px", xxl: "36px" },
                }}
            >
                Got Questions? We’ve Got Answers
            </Typography>

            <Box 
                sx={{ 
                width: { xs: "100%", xxl: "70%" }, 
                margin: "0 auto", 
                borderRadius: "20px",
                overflow: "hidden", 
                }}
            >
                {faqs.map((faq, index) => (
                <Accordion
                    key={index}
                    expanded={activeIndex === index}
                    onChange={() => handleAccordionChange(index)}
                    sx={{
                    borderRadius: index === 0 ? "20px 20px 20px 20px" : index === faqs.length - 1 ? "20px 20px 20px 20px" : "20px",
                    mb: 2,
                    overflow: "hidden",
                    margin: "5px 0",
                    fontSize: { xs: "18px", xxl: "22px" }, 
                    lineHeight: "24px",
                    }}
                >
                    <AccordionSummary
                    sx={{
                        backgroundColor: activeIndex === index ? "#20defa" : "#D9D9D9",
                        color: activeIndex === index ? "#002077" : "#000",
                        fontSize: { xs: "18px", xxl: "22px" },  
                        lineHeight: "24px",
                        fontWeight: "bold",
                        borderRadius: "inherit",
                        textAlign: "center",
                        display: "flex",
                        justifyContent: "center",
                        padding: 0,
                        "& .MuiAccordionSummary-content": {
                        margin: 0,
                        padding: 0,
                        justifyContent: "center",
                        },
                    }}
                    >
                    {faq.question}
                    </AccordionSummary>
                    <AccordionDetails
                    sx={{
                        backgroundColor: "#FFFFFF",
                        color: "#5A5A5A",
                        py: 2,
                        px: { xs: 2, xxl: 2 },
                    }}
                    >
                    {faq.answer.map((line, idx) => (
                        <Typography 
                        key={idx}
                        sx={{
                            color: "#000",
                            textTransform: "none",
                            fontWeight: "300", 
                            fontSize: { xs: "12px", xxl: "16px" }, 
                            lineHeight: "16px",
                            letterSpacing: "normal", 
                        }}
                        dangerouslySetInnerHTML={{ __html: line }}
                        />
                    ))}
                    </AccordionDetails>
                </Accordion>
                ))}
            </Box>
        </Box>
    );
};

export default FaqSection;